const actions = {
    PUBLIC_MINIPOS_ORDER_READ_REQUEST: 'PUBLIC_MINIPOS_ORDER_READ_REQUEST',
    PUBLIC_MINIPOS_ORDER_READ_SUCCESS: 'PUBLIC_MINIPOS_ORDER_READ_SUCCESS',
    PUBLIC_MINIPOS_ORDER_READ_ERROR: 'PUBLIC_MINIPOS_ORDER_READ_ERROR',

    PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_REQUEST: 'PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_REQUEST',
    PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_SUCCESS: 'PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_SUCCESS',
    PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_ERROR: 'PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_ERROR',

    readPublicMiniPosOrder: (hash, subdomain) => ({
        type: actions.PUBLIC_MINIPOS_ORDER_READ_REQUEST,
        hash,
        subdomain,
    }),

    requestEInvoice: (request, hash, subdomain) => ({
        type: actions.PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_REQUEST,
        request,
        hash,
        subdomain,
    }),
};
export default actions;
